import MainLayout from "../pages/MainLayout/MainLayout";
import Quiz from "../pages/Quiz/Quiz";
import Result from "../pages/Result/Result";
import Start from "../pages/Start/Start";
import Survey from "../pages/Survey/Survey";
import { SurveyProvider } from "../pages/Survey/Survey.context";
// import Questions from "../pages/Quections/Quections";

export const ROUTES = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <Start /> },
      { path: "/start", element: <Start /> },
      {
        path: "/survey",
        element: (
          <SurveyProvider>
            <Survey />
          </SurveyProvider>
        ),
      },
      { path: "/result", element: <Result /> },
    ],
  },
];
